import { LayerControls } from './layer-controls.js';


export function LayerObjectFactory (pEditor, pLayer)
{
  var absElementControl;

  if (BEditor.browser.isWebKit || BEditor.browser.isGecko)
  {
    absElementControl = new LayerControls(pEditor, pLayer);
  }

  this.fixAllAbsElements = (BEditor.browser.isWebKit || BEditor.browser.isGecko) ? fixAllAbsElements : function(){};
  this.fixAbsElement = (BEditor.browser.isWebKit || BEditor.browser.isGecko) ? fixAbsElement : function(){};
  this.deleteAbsElement = (BEditor.browser.isWebKit || BEditor.browser.isGecko) ? deleteAbsElement : function(){};
  this.selectNewElement = (BEditor.browser.isWebKit || BEditor.browser.isGecko) ? selectNewElement : function(){};
  this.fixAbsGecko = (BEditor.browser.isWebKit || BEditor.browser.isGecko) ? fixAbsGecko : function(){};

  this.deselect = (BEditor.browser.isWebKit || BEditor.browser.isGecko) ? absElementControl.deselect : function(){};
  this.unload = (BEditor.browser.isWebKit || BEditor.browser.isGecko) ? absElementControl.unload : function(){};

  var prevElementX = 0,
      prevElementY = 0;


  function fixAllAbsElements ()
  {
    var i,
      elements = pEditor.iFrameDoc.body.getElementsByTagName('*');

    for (i = 0; i < elements.length; i++)
    {
      if (pEditor.$Style(elements[i], 'position') === 'absolute' && !elements[i].isAbsFixed)
      {
        fixAbsElement(elements[i], false);
      }
    }
  }


  function fixAbsElement (element, isSelectElement)
  {
    element.isAbsFixed = true;

    if (isSelectElement)
    {
      selectNewElement(element);
    }

    BEditor.domHandlers.addHandler(element, 'mouseover', absElementControl.show);
    BEditor.domHandlers.addHandler(element, 'mouseout', absElementControl.hide);
  }


  function deleteAbsElement (element)
  {
    if (element)
    {
      BEditor.domHandlers.removeHandler(element, 'mouseover', absElementControl.show);
      BEditor.domHandlers.removeHandler(element, 'mouseout', absElementControl.hide);

      absElementControl.delAbsElement();

      element.isAbsFixed = false;
    }
  }


  function fixAbsGecko (e)
  {
    var element = pLayer.helpers.isRangeElementPositionAbsolute();

    if (e)
    {
      if (e.type === 'mouseover')
      {
        prevElementX = e.currentTarget.offsetLeft;
        prevElementY = e.currentTarget.offsetTop;

        absElementControl.show(e);
      }
      else if (e.type === 'mouseout')
      {
        absElementControl.hide(e);
      }
    }

    if (element)
    {
      fixAbsGeckoCoordinates();

      BEditor.domHandlers.removeHandler(pEditor.iFrameDoc.body, 'mousedown', startCheckAbsMove);
      BEditor.domHandlers.addHandler(pEditor.iFrameDoc.body, 'mousedown', startCheckAbsMove);
    }


    function startCheckAbsMove ()
    {
      BEditor.domHandlers.addHandler(pEditor.iFrameDoc.body, 'mouseup', endCheckAbsMove);
    }


    function endCheckAbsMove ()
    {
      BEditor.domHandlers.removeHandler(pEditor.iFrameDoc.body, 'mousedown', startCheckAbsMove);
      BEditor.domHandlers.removeHandler(pEditor.iFrameDoc.body, 'mouseup', endCheckAbsMove);

      fixAbsGecko();
    }


    function fixAbsGeckoCoordinates ()
    {
      var elementSelection,
          elementRange,
          elementOffsetLeft = element.offsetLeft,
          elementOffsetTop = element.offsetTop;

      if (!element || (elementOffsetLeft === prevElementX && elementOffsetTop === prevElementY))
      {
        return;
      }

      prevElementX = elementOffsetLeft;
      prevElementY = elementOffsetTop;

      elementSelection = iFrame.getSelection();

      if (elementSelection)
      {
        elementSelection.removeAllRanges();
        elementSelection.selectAllChildren(pEditor.iFrameDoc.body);
        elementSelection.removeAllRanges();
        elementRange = pEditor.iFrameDoc.createRange();
        elementRange.selectNodeContents(pEditor.iFrameDoc.body);
        elementRange.collapse(true);
        elementSelection.addRange(elementRange);

        elementRange.selectNodeContents(element);
        elementRange.collapse(false);
        elementSelection.addRange(elementRange);
      }

      absElementControl.select(element, true);
      absElementControl.setMovedElementXY();
    }
  }


  function selectNewElement (element, isImmediate)
  {
    if (absElementControl)
    {
      absElementControl.select(element, isImmediate);
    }
  }

}